import { render, staticRenderFns } from "./orderReport.vue?vue&type=template&id=a27a5248"
import script from "./orderReport.vue?vue&type=script&lang=js"
export * from "./orderReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports